import {
  Directive,
  effect,
  ElementRef,
  HostListener,
  OnDestroy,
  OnInit,
  Renderer2,
} from '@angular/core'
import { PluginListenerHandle } from '@capacitor/core'
import { Keyboard } from '@capacitor/keyboard'
import { DeviceModeRepository } from '../../repositories/device-mode.repository'

@Directive({
  selector: 'ion-input[efpInputKeyboard]',
})
export class InputKeyboardDirective implements OnInit, OnDestroy {
  private element: HTMLIonInputElement
  private hideKeyboardListener?: PluginListenerHandle
  private isMobile = false

  constructor(
    element: ElementRef,
    private readonly renderer: Renderer2,
    private readonly deviceModeRepository: DeviceModeRepository
  ) {
    this.element = element.nativeElement as HTMLIonInputElement

    effect(() => {
      this.isMobile = this.deviceModeRepository.isMobileSignal() ?? false
    })
  }

  async ngOnInit(): Promise<void> {
    this.renderer.setAttribute(this.element, 'autofocus', `${false}`)
    this.renderer.setAttribute(this.element, 'tabindex', `${-1}`)

    // Keyboard not available in Web
    if (this.isMobile) {
      this.hideKeyboardListener = await Keyboard.addListener('keyboardWillHide', () =>
        this.hideKeyboard()
      )
    }
  }

  @HostListener('keyup.enter')
  hideKeyboard(): void {
    if (this.isMobile) {
      void Keyboard.hide()
      this.element.blur() // .setBlur()
    }
  }

  async ngOnDestroy(): Promise<void> {
    await this.hideKeyboardListener?.remove()
  }
}
